module.exports = __webpack_public_path__ + "static/media/ico-interesting-like.b27a12f9.svg";